import React, { Component } from 'react';
import { ACTIVE_PROFILE } from '../../config';
// import shopriteSSORedirectLink from '../../assets/js/shopriteSSORedirectLink.json';

// Components
import {
  Container,
  Row,
  Col
} from 'reactstrap';
import {ResponsiveImage} from 'dabbl-react-components';
import Jumbotron from './components/Jumbotron';

// Data
import waysToSaveData from '../data/waysToSave';

const WaysToSaveBar = () => {
  return (
    <Container className="HomePage_bar">
      <Row className="HomePage_bar_header">
        <Col xs={12}>
          <h1 className="text-center">One. Two. Save.</h1>
        </Col>
      </Row>

      <Row>
        {/* Use custom card stylings to prevent border */}
        {waysToSaveData.map((d,i) => (
          <Col xs={12} sm={4} key={i}>
            <ResponsiveImage
              src={d.imgUrl}
              alt={d.text}
              aspectRatio="1:1"
            />

            <h6 className="HomePage_card_title">{d.title}</h6>
            <p className="HomePage_card_text">{d.text}</p>
            {d.subtext && (
              <p className="HomePage_card_text">{d.subtext}</p>
            )}
          </Col>
        ))}
      </Row>
    </Container>
  );
}

class HomePage extends Component {

  handleGetStartedClick() {
    const {
      isAuthenticated,
      seenTutorial,
      history
    } = this.props;

    if (!isAuthenticated) {
      if (ACTIVE_PROFILE === 'prod' || ACTIVE_PROFILE === 'production' || ACTIVE_PROFILE === 'stage' || ACTIVE_PROFILE === 'test')
        history.push('/saml');
      else
        history.push('/login');
    }

    else {
      // if (seenTutorial)
        history.push('/app/campaigns');
      // else
      //   history.push('/app/tutorial');
    }
  }

  render() {
    return (
      <div className="HomePage">
        <Jumbotron onBtnClick={() => this.handleGetStartedClick()} />
        <WaysToSaveBar />
      </div>
    );
  }

}

export default HomePage;



// WEBPACK FOOTER //
// ./src/pages/Home/Home.js